import Vue from 'vue'
import * as Sentry from '@klook/sentry-vue'
import getUserInfo from '@activity/utils/getUserInfo.js'
import { isMerchant } from '@/env'

const ignoreErrors = [
  ...Sentry.defaultIgnoreErrors,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  '//localhost',
  '//127.0.0.1',
  '//0.0.0.0',
  // merchant app
  /^Argument 1 \('target'\) to IntersectionObserver.observe must be an instance of Element$/,
  // el-form-item prop error
  /^please transfer a valid prop path to form item!$/,
  /^Load failed$/,
  // try catch 捕获到 Promise.reject 为 undefined
  /^Non-Error promise rejection captured with value: undefined/i,
  /^Non-Error promise rejection captured with value: false/i,
  // cloudinary error ($.fn.cloudinary_upload_widget)
  /^can't access property "sendDisplayChangedCallback", i is null/i,
  /^Cannot read properties of null \(reading 'sendDisplayChangedCallback'\)/i,
  /^null is not an object \(evaluating 'i\.sendDisplayChangedCallback'\)$/i,
  // todo actNavLib 路由重复跳转
  /^Avoided redundant navigation to current location/i,
  /^NetworkError when attempting to fetch resource.$/,
  /^Return statements are only valid inside functions.$/,
  /^Unexpected end of JSON input$/,
  // Network
  /^UnknownError: Connection to Indexed Database server lost\. Refresh the page to try again$/,
  /^Load failed$/,
  /^Request failed with status code 401/i,
  /^Failed to fetch$/,
  /^Event `Event` \(type=error\) captured as exception/i,
  /^Network Error/i,
  // KlkAntAreaMap - GoogleMaps
  /^Map: Expected mapDiv of type HTMLElement but was passed null./i,
  /^Map container div not exist/i,
  /^Cannot read properties of undefined \(reading 'maps'\)/i,
  // vue-router
  /^Navigation cancelled from/i,
  /^Navigation aborted from/i,
  /^Redirected when going from "([^"]+)" to "([^"]+)" via a navigation guard.$/,
  // antd
  /^A DOM element reference is required/i,
  // antd drawer error - Mobile Safari UI/WKWebView
  /^undefined is not an object \(evaluating ['']?this\.startPos\.x['']?\)$/i,
  // compatibility
  /^undefined is not an object \(evaluating 'c\.IE'\)/i,
  // sentry
  /Manually aborted/i,
  /^undefined$/,
  /CustomEvent:?\s*Event\s*`CustomEvent`\s*\(type=unhandledrejection\)\s*captured as promise rejection/i,
  /^Cannot read properties of undefined \(reading 'x'\)/,
  /^null is not an object \(evaluating '[^']+'\)$/,
  /^this\.(qj|Vi)\.close is not a function\. \(In 'this\.(qj|Vi)\.close\(\)', 'this\.(qj|Vi)\.close' is undefined\)/,
  /^GEOCODER_GEOCODE: ERROR: A geocoding request could not be processed due to a server error\. The request may succeed if you try again\.$/,
  /^Invalid array length$/i
]

const isAxiosError = (hint) => {
  return !!hint?.originalException?.isAxiosError
}

export const sentry = async (context) => {
  if (window.location.host.includes('.klooktest.')) {
    return
  }

  const { router } = context
  const debugKey = '__sentry_debug'
  const sampleRate = +(process.env.SENTRY_SAMPLE_RATE || 0.1)
  const tracesSampleRate = +(process.env.SENTRY_TRANCES_SAMPLE_RATE || 0.01)
  const environment = process.env.NODE_ENV || 'development'
  const userInfo = await getUserInfo()

  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment,
    sampleRate,
    tracesSampleRate,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    debug: !!localStorage.getItem(debugKey),
    ignoreErrors,
    beforeSend(event, hint) {
      if (isAxiosError(hint)) {
        return null
      }
      if (localStorage.getItem(debugKey)) {
        console.log('sentry beforeSend event:', event, 'hint:', hint)
      }
      return event
    }
  })

  Vue.prototype.$sentry = Sentry

  Sentry.configureMeta({
    commitHash: process.env.COMMIT_SHA,
    language: window.KLK_LANG || '',
    ...(isMerchant
      ? {
          merchantId: userInfo.merchant_id,
          merchantName: userInfo.merchant_name
        }
      : {
          accountName: userInfo.account_name,
          accountId: userInfo.account_id
        })
  })
}

export default sentry
